module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABVklEQVR4AZzTTytEYRTH8TtTlLImSv7tbCzYWEhWVrbY4R2QUiynxEL+lL1ShpIXoKyUjewtLNlZyUao8Tm3ZrpXd4bcft/7nOc855zO8zz3lpOCp1arjeMa79gqCGm4cgUED+HM6h06cYgNvl5jodICAjqwL+IB45jHBI5RQhcKlRawUsES1jBSKpUuUGP/qnqBMZFVSUf4ZP9Z9QLR5kdk2coA9nBv3oZU5rN4RgX9qdOrXoCZJBZWGY+Ywzmy3dyYn2AFp0iVK8ATp79oHLSVXWND5q/Y5LjEG1LlCgi4RdVKu27iFpitlSsgqRvbUp5whXa0VK6AyGhx2XiAYaQHa2yqnwXiO+izjQpemmZlFnIFJH0he/KZ0GKzbM/TluJTHWOvZeGP7RiSGf6FwGQQPezIS6KDuNMRzknE1WVZ5wvteMVPFkyxRxF5SVnLvfiP0j/0GwAA///sMz3aAAAABklEQVQDALR9hiFZ62YzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/jggl.png
// module id = +yvp
// module chunks = 16